import React from 'react';
import { StyleSheet } from 'react-native';
import { TextInput } from '~/components/core';
import { scaleSize } from '~/constants/scale';
import { useStyles } from '~/hooks';
import { Theme } from '~/theme';
import { PaymentProvider1BillingField } from '~/api-services/CustomerInfoService/types';

type Props = {
    idx: number;
    fields: PaymentProvider1BillingField[];
    onChangeBillingField: Function;
};

export default function BillingFieldComponentType({ idx, fields, onChangeBillingField }: Props) {
    const styles = useStyles(stylesGenerator);
    const field = fields[idx];
    const isEmail = field.format === 'email';
    const hasError = field.showValidation || field.showValidationEmail;
    return (
        <TextInput
            autoCapitalize={isEmail ? 'none' : 'words'}
            autoCorrect={false}
            value={field.value || ''}
            onChangeText={(text) => {
                onChangeBillingField(idx, text);
            }}
            keyboardType={isEmail ? 'email-address' : 'default'}
            returnKeyType="next"
            // Matches the height of Select and DateField so the form reads as one column of controls.
            containerStyle={[styles.field, hasError ? styles.fieldError : null]}
        />
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        field: {
            height: scaleSize(44),
            // See DateField: centring the child here makes Android clip the text.
            paddingVertical: 0,
        },
        fieldError: {
            borderColor: theme.alert,
        },
    });
